var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 34,
    fill: "none",
    className: "injected-svg",
    "data-src": "/static/media/premium-badge.b12e44af575ef72de142a052ff425f27.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.252 3.148c.761-1.372 2.734-1.372 3.496 0l.803 1.444a2 2 0 0 0 2.298.952l1.588-.454c1.509-.431 2.904.964 2.473 2.473l-.454 1.588a2 2 0 0 0 .952 2.298l1.444.803c1.372.761 1.372 2.734 0 3.496l-1.444.803a2 2 0 0 0-.952 2.298l.454 1.588c.431 1.509-.964 2.904-2.473 2.473l-1.588-.454a2 2 0 0 0-2.298.952l-.803 1.444c-.762 1.372-2.735 1.372-3.496 0l-.803-1.444a2 2 0 0 0-2.298-.952l-1.588.454c-1.509.431-2.904-.964-2.473-2.473l.454-1.588a2 2 0 0 0-.952-2.298l-1.444-.803c-1.372-.761-1.372-2.734 0-3.496l1.444-.803a2 2 0 0 0 .952-2.298L7.09 7.563c-.431-1.509.964-2.904 2.473-2.473l1.588.454a2 2 0 0 0 2.298-.952l.803-1.444Z",
    fill: "#F3A952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 10.513a.34.34 0 0 0-.397-.005l-2.018 1.377a.372.372 0 0 0-.097.505c.116.18.178.388.178.605 0 .602-.473 1.092-1.055 1.092s-1.055-.49-1.055-1.092c0-.354.17-.688.451-.893a.372.372 0 0 0 .086-.507l-1.655-2.449a.356.356 0 0 0-.576 0l-1.655 2.449a.372.372 0 0 0 .086.506c.282.206.45.54.45.894 0 .602-.472 1.092-1.054 1.092-.582 0-1.055-.49-1.055-1.092 0-.217.062-.426.178-.605a.372.372 0 0 0-.097-.505l-2.018-1.377a.34.34 0 0 0-.398.005.37.37 0 0 0-.139.386l1.43 5.824a.348.348 0 0 0 .399.271 24.409 24.409 0 0 1 8.322 0 .355.355 0 0 0 .399-.27l1.43-5.825a.37.37 0 0 0-.14-.386Z",
    fill: "#000012"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.119,
    y: 2.119,
    width: 31.762,
    height: 31.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_735_5404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_735_5404",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.6a4cdaada6be00e8c052de17dbba7a3a.svg";
export { ForwardRef as ReactComponent };